import React from 'react'
import { connect } from 'react-redux'
import { withStyles, AppBar, Toolbar } from '@material-ui/core'

import { GarageInfo } from '../atoms/GarageInfo'
import { getGarageName, getGarageAddress } from '../../store/garage/selectors'
import { getAppDomain } from '../../store/app/selectors'

const styles = theme => ({
  grow: {
    flexGrow: 1,
    lineHeight: '1em'
  },
  logo: {
    maxHeight: 50,
    marginRight: theme.spacing.unit * 2
  }
})

const HeaderBase = ({ classes, domain, name, address }) => {
  return (
    <AppBar position="static">
      <Toolbar>
        <img
          src={`assets/logos/${domain}.jpg`}
          alt="logo"
          className={classes.logo}
        />
        <div className={classes.grow} />
        <GarageInfo name={name} address={address} />
      </Toolbar>
    </AppBar>
  )
}

export const Header = withStyles(styles)(HeaderBase)

const mapStateToProps = state => ({
  domain: getAppDomain(state),
  name: getGarageName(state),
  address: getGarageAddress(state)
})

export default connect(mapStateToProps)(Header)
